<template>
  <div class="container is-fluid">
    <div class="box has-background-light">
      <div class="level">
        <div class="level-left">
          <h5 class="title is-5 has-text-primary">Demonstração de Resultado</h5>
        </div>
        <div class="level-right">
          <button
            class="button is-primary is-rounded is-small"
            @click="processar()"
            :disabled="this.cmbPeriodoPerfil.estaFechado"
            :class="{ 'is-loading': isProcessing }"
          >
            <span class="icon is-small">
              <i class="fas fa-cog"></i>
            </span>
            <span>Processar</span>
          </button>
        </div>
      </div>

      <form @submit.prevent="filterRecords" class="filter-form">
        <div class="field is-grouped is-grouped-multiline">
          <div class="control">
            <label class="label is-small">Tipo de Período</label>
            <div class="select is-small is-fullwidth">
              <select v-model="cmbTipoPeriodo" @change="selectTipoPeriodo()">
                <option value="0" disabled>Selecione um tipo de período</option>
                <option v-for="td in tiposPeriodo" :key="td.id" :value="td.id">
                  {{ td.descricao }}
                </option>
              </select>
            </div>
          </div>

          <div class="control">
            <label class="label is-small">Perfil</label>
            <div class="select is-small is-fullwidth">
              <select v-model="cmbPerfil" @change="selectPerfil()">
                <option value="0" disabled>Selecione um perfil</option>
                <option
                  v-for="perfilUsuario in perfisUsuario"
                  :key="perfilUsuario.id"
                  :value="perfilUsuario.perfil.id"
                >
                  {{ perfilUsuario.perfil.descricao }}
                </option>
              </select>
            </div>
          </div>

          <div class="control">
            <label class="label is-small">Período</label>
            <div class="select is-small is-fullwidth">
              <select v-model="cmbPeriodoPerfil" @change="selectPeriodoPerfil()">
                <option value="0" disabled>Selecione um período</option>
                <option
                  v-for="periodoPerfil in periodosPerfis"
                  :key="periodoPerfil.id"
                  :value="periodoPerfil"
                >
                  {{ periodoPerfil.periodo.descricao }}
                </option>
              </select>
            </div>
          </div>

          <div class="control">
            <label class="label is-small">Demonstração de Resultado</label>
            <div class="select is-small is-fullwidth">
              <select v-model="cmbDemonstracaoResultadoVersao">
                <option value="0" disabled
                  >Selecione uma demonstração de resultado</option
                >
                <option
                  v-for="dre in demonstracoesResultados"
                  :key="dre.id"
                  :value="dre.demonstracao_resultado_versao"
                >
                  {{ dre.demonstracao_resultado_versao.descricao }}
                </option>
              </select>
            </div>
          </div>

          <div class="control is-align-self-flex-end">
            <button
              type="submit"
              class="button is-info is-rounded is-small"
              :class="{ 'is-loading': isProcessing }"
            >
              <span class="icon is-small">
                <i class="fas fa-filter"></i>
              </span>
              <span>Filtrar</span>
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="modal" :class="{ 'is-active': isProcessing }">
      <div class="modal-background"></div>
      <div class="modal-content has-background-white p-5">
        <p class="has-text-centered has-text-weight-semibold mb-3">
          Processando...
        </p>
        <progress class="progress is-primary is-large" max="100"></progress>
      </div>
    </div>

    <div class="box has-background-white" v-show="showInfo">
      <div class="table-container">
        <table class="table is-fullwidth is-hoverable is-bordered is-narrow">
          <thead>
            <tr class="has-background-grey-lighter">
              <th class="has-text-left is-size-7">DRE</th>
              <th class="has-text-centered is-size-7">
                {{ anoMesReferencia | datePorTipo(cmbTipoPeriodo) }}
              </th>
              <th class="has-text-centered is-size-7 has-text-grey-light">AV%</th>
              <th
                class="has-text-centered is-size-7"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                {{ anoMesMesAnteriorReferencia | datePorTipo(cmbTipoPeriodo) }}
              </th>
              <th
                class="has-text-centered is-size-7 has-text-grey-light"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                AH%
              </th>
              <th class="has-text-centered is-size-7">
                {{ anoMesAnoAnteriorReferencia | datePorTipo(cmbTipoPeriodo) }}
              </th>
              <th class="has-text-centered is-size-7 has-text-grey-light">AH%</th>
              <th
                class="has-text-centered is-size-7"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                Acumulado Ano
              </th>
              <th
                class="has-text-centered is-size-7 has-text-grey-light"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                AV%
              </th>
              <th
                class="has-text-centered is-size-7"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                Acum. Ano Anterior
              </th>
              <th
                class="has-text-centered is-size-7 has-text-grey-light"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                AH%
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dre in demonstracoesResultadosPeriodo" :key="dre.id">
              <td
                class="is-size-7"
                :class="{
                  'has-text-weight-bold':
                    dre.demonstracao_resultado_versao_config.e_negrito,
                }"
              >
                {{ dre.demonstracao_resultado_versao_config.descricao }}
              </td>
              <td class="has-text-centered is-size-7">
                {{ dre.valor_periodo | numberFormat }}
              </td>
              <td class="has-text-centered is-size-7 has-text-info has-text-weight-bold">
                {{ dre.perc_av | numberFormat }}
              </td>
              <td
                class="has-text-centered is-size-7"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                {{ dre.valorMesAnterior | numberFormat }}
              </td>
              <td
                class="has-text-centered is-size-7 has-text-weight-bold"
                :class="{
                  'has-text-success': dre.cor_ah_mes_anterior == '1',
                  'has-text-danger': dre.cor_ah_mes_anterior == '2',
                  'has-text-info': dre.cor_ah_mes_anterior == '3',
                }"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                {{ dre.perc_ah_mes_anterior | numberFormat }}
              </td>
              <td class="has-text-centered is-size-7">
                {{ dre.valorAnoAnterior | numberFormat }}
              </td>
              <td
                class="has-text-centered is-size-7 has-text-weight-bold"
                :class="{
                  'has-text-success': dre.cor_ah_ano_anterior == '1',
                  'has-text-danger': dre.cor_ah_ano_anterior == '2',
                  'has-text-info': dre.cor_ah_ano_anterior == '3',
                }"
              >
                {{ dre.perc_ah_ano_anterior | numberFormat }}
              </td>
              <td
                class="has-text-centered is-size-7"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                {{ dre.valor | numberFormat }}
              </td>
              <td
                class="has-text-centered is-size-7 has-text-info has-text-weight-bold"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                {{ dre.perc_av_valor_acumulado | numberFormat }}
              </td>
              <td
                class="has-text-centered is-size-7"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                {{ dre.valor_periodo_anterior | numberFormat }}
              </td>
              <td
                class="has-text-centered is-size-7 has-text-weight-bold"
                :class="{
                  'has-text-success': dre.cor_ah_periodo_anterior == '1',
                  'has-text-danger': dre.cor_ah_periodo_anterior == '2',
                  'has-text-info': dre.cor_ah_periodo_anterior == '3',
                }"
                v-if="cmbTipoPeriodo != '6' && cmbTipoPeriodo != '7'"
              >
                {{ dre.perc_ah_periodo_anterior | numberFormat }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '../../services/config';

export default {
  name: 'DemonstracaoResultadoPeriodo',
  data() {
    return {
      periodosPerfis: [],
      perfisUsuario: [],
      demonstracoesResultados: [],
      demonstracoesResultadosPeriodo: [],
      linhasDemonstracaoResultado: [],
      tiposPeriodo: [],
      cmbPerfil: 0,
      cmbPeriodoPerfil: 0,
      cmbDemonstracaoResultadoVersao: 0,
      cmbTipoPeriodo: 0,
      anoMesReferencia: '',
      anoMesMesAnteriorReferencia: '',
      anoMesAnoAnteriorReferencia: '',
      anoMes3AnosAnteriorReferencia: '',
      anoMes5AnosAnteriorReferencia: '',
      anoMes10AnosAnteriorReferencia: '',
      showInfo: false,
      isProcessing: false,
    };
  },
  methods: {
    filterRecords() {
      if (this.cmbPerfil == 0) {
        alert('Selecione um perfil');
        return;
      }
      if (this.cmbPeriodoPerfil == 0) {
        alert('Selecione um período');
        return;
      }
      if (this.cmbDemonstracaoResultadoVersao == 0) {
        alert('Selecione um demonstrativo de resultado');
        return;
      }
      http
        .get('demonstracaoResultadoPeriodo/listar/', {
          params: {
            idPeriodoPerfil: this.cmbPeriodoPerfil.id,
          },
        })
        .then((response) => {
          this.demonstracoesResultadosPeriodo = response.data.results;
          if (this.demonstracoesResultadosPeriodo.length != 0) {
            this.showInfo = true;
          } else {
            this.showInfo = false;
            alert('Não há dados associados aos parâmetros informados!');
          }
        });
    },
    selectTipoPeriodo() {
      this.cmbPerfil = 0;
      this.cmbPeriodoPerfil = 0;
      this.cmbDemonstracaoResultadoVersao = 0;
      this.demonstracoesResultadosPeriodo = [];
      this.anoMesReferencia = '';
      this.anoMesMesAnteriorReferencia = '';
      this.anoMesAnoAnteriorReferencia = '';
      this.anoMes3AnosAnteriorReferencia = '';
      this.anoMes5AnosAnteriorReferencia = '';
      this.anoMes10AnosAnteriorReferencia = '';
    },
    selectPerfil() {
      http
        .get('periodoPerfil/listar/', {
          params: {
            idPerfil: this.cmbPerfil,
            idTipoPeriodo: this.cmbTipoPeriodo,
            semPaginacao: 'S',
          },
        })
        .then((response) => {
          this.periodosPerfis = response.data.results;
          if (this.periodosPerfis.length == 0) {
            alert('Não há períodos associados ao perfil selecionado!');
          }
        });
    },
    selectPeriodoPerfil() {
      http
        .get('demonstracaoResultadoVersao/listarDREs/', {
          params: {
            idVersaoPlanoContas: this.cmbPeriodoPerfil.versao_plano_contas.id,
          },
        })
        .then((response) => {
          this.demonstracoesResultados = response.data.results;
          this.anoMesReferencia = this.cmbPeriodoPerfil.periodo.data;
          this.anoMesMesAnteriorReferencia =
            this.cmbPeriodoPerfil.periodo.data_mes_anterior;
          this.anoMesAnoAnteriorReferencia =
            this.cmbPeriodoPerfil.periodo.data_ano_anterior;
          this.anoMes3AnosAnteriorReferencia =
            this.cmbPeriodoPerfil.periodo.data_3anos_anteriores;
          this.anoMes5AnosAnteriorReferencia =
            this.cmbPeriodoPerfil.periodo.data_5anos_anteriores;
          this.anoMes10AnosAnteriorReferencia =
            this.cmbPeriodoPerfil.periodo.data_10anos_anteriores;
          if (this.demonstracoesResultados.length == 0) {
            alert(
              'Não há demonstrativos de resultados associados a versão associada ao período selecionado!'
            );
          }
        });
      if (this.cmbDemonstracaoResultadoVersao != 0) {
        this.filterRecords();
      }
    },
    processar() {
      if (this.cmbPerfil == 0) {
        alert('Perfil não selecionado!');
        return;
      }
      if (this.cmbPeriodoPerfil == 0) {
        alert('Período não selecionado!');
        return;
      }
      if (this.cmbDemonstracaoResultadoVersao == 0) {
        alert('Demonstração de Resultado não selecionado!');
        return;
      }
      if (window.confirm('Confirma o processamento do demonstrativo de resultado?')) {
        this.isProcessing = true;
        http
          .put(
            '/demonstracaoResultadoPeriodo/processar/' + this.cmbPeriodoPerfil.id,
            this.cmbDemonstracaoResultadoVersao
          )
          .then((response) => {
            if (response.status == 204) {
              this.filterRecords();
              this.isProcessing = false;
              alert('Processamento concluído!');
            }
          })
          .catch((e) => {
            this.isProcessing = false;
            console.log(e);
          });
      }
    },
  },
  mounted() {},
  created() {
    http.get('compartilharPerfis/listarPerfis').then((response) => {
      this.perfisUsuario = response.data.results;
    });
    http.get('tiposPeriodo/listar').then((response) => {
      this.tiposPeriodo = response.data.results;
    });
  },
};
</script>

<style scoped>
</style>